import React from 'react';
import { hooks } from '@lifesize/clients.sdk';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import { withRouter } from 'react-router-dom';
import { openFullScreenModal } from 'actions/FullScreenModal';
import { SCHEDULE_MODAL } from 'constants/ScheduleModal';
import { START_CALL_MODAL } from 'constants/StartCallModal';
import Welcome from 'components/Welcome/Welcome';
import { toggleMinimized } from 'actions/InCall/InCallVideo';

function mapDispatchToProps(dispatch) {
  return {
    openCallModal: () => {
      dispatch(openFullScreenModal(START_CALL_MODAL));
    },
    openScheduleModal: () => {
      dispatch(openFullScreenModal(SCHEDULE_MODAL));
    },
    returnToCall: () => dispatch(toggleMinimized())
  };
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    name: _get(state, 'nucleus.userProfile.name'),
    loginCount: _get(state, 'app.jwt.loginCount')
  };
}

const ConnectedComponent = withRouter(connect(mapStateToProps, mapDispatchToProps)(Welcome));

const FunctionalComponent = (props) => {
  const callState = hooks.useCallState();
  const callConnected = hooks.useCallConnected();
  const callContactName = _get(callState, 'contact.displayName');
  const callStartTime = _get(callState, 'startTime');
  const isCallMeeting = _get(callState, 'contact.isMeeting', false);
  return (
    <ConnectedComponent
      {...props}
      callContactName={callContactName}
      callStartTime={callStartTime}
      isCallConnected={callConnected}
      isCallMeeting={isCallMeeting}
    />
  );
};
export { ConnectedComponent as WelcomeContainer };
export default FunctionalComponent;
